import App from './App.js'

const app = new App()